export function getQuestions(otherName) {
  return [
    {
      text: `If your connection with ${otherName} were a place, what kind of place would it be?`,
      hint: "Somewhere real or imagined. What's the vibe?"
    },
    {
      text: `What's something ${otherName} does that you didn't expect to like, but you do?`,
      hint: "Could be small or big."
    },
    {
      text: `If this relationship had a soundtrack, what would it sound like?`,
      hint: "A genre, an artist, a specific song — or just a feeling."
    },
    {
      text: `What's something you'd only do or say with ${otherName}, not with most other people?`,
      hint: "An inside thing, a habit, a comfort."
    },
    {
      text: `If you had to describe this connection in exactly three words, what would they be?`,
      hint: "First instinct, no overthinking."
    }
  ];
}

export function generateCode() {
  return Math.floor(1000 + Math.random() * 9000).toString();
}

export function parseBlocks(raw) {
  const tags = ["LABEL", "OVERALL", "Q1", "Q2", "Q3", "Q4", "Q5"];
  const blocks = [];

  for (let i = 0; i < tags.length; i++) {
    const marker = `[${tags[i]}]`;
    const start = raw.indexOf(marker);
    if (start === -1) continue;
    const contentStart = start + marker.length;

    // Find the next tag
    let nextStart = -1;
    for (let j = i + 1; j < tags.length; j++) {
      const idx = raw.indexOf(`[${tags[j]}]`, contentStart);
      if (idx !== -1) { nextStart = idx; break; }
    }

    let content = nextStart === -1
      ? raw.slice(contentStart)
      : raw.slice(contentStart, nextStart);

    // Strip any leading line that looks like a repeated instruction
    content = content
      .split("\n")
      .filter(line => {
        const l = line.trim().toLowerCase();
        return !(l.startsWith("compare") && l.includes("answers to question")) &&
               !(l.startsWith("same for question")) &&
               !(l.startsWith("a warm") && l.includes("flowing")) &&
               !(l.startsWith("the single relationship"));
      })
      .join("\n")
      .trim();

    blocks.push({ tag: tags[i], content });
  }

  if (blocks.length < 3) return [{ tag: "OVERALL", content: raw.trim() }];
  return blocks;
}

export const s = {
  bg: { minHeight: "100vh", background: "#0e1410", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "3rem 1.5rem", fontFamily: "'Inter', sans-serif" },
  container: { width: "100%", maxWidth: 560, display: "flex", flexDirection: "column", gap: "2rem" },
  progressTrack: { height: 2, background: "#1e2a1f", borderRadius: 99, overflow: "hidden" },
  progressFill: { height: "100%", background: "linear-gradient(90deg, #7a9e7e, #c8924a)", borderRadius: 99, transition: "width 0.8s ease" },
  step: { display: "flex", flexDirection: "column", gap: "1.5rem" },
  eyebrow: { fontSize: "0.72rem", color: "#7a9e7e", letterSpacing: "0.1em", textTransform: "uppercase" },
  display: { fontFamily: "'Cormorant Garamond', serif", fontSize: "2.4rem", lineHeight: 1.2, color: "#e8e2d4", fontWeight: 300 },
  body: { fontSize: "0.9rem", color: "#8a9a8b", lineHeight: 1.75 },
  input: { background: "#131a14", border: "1px solid #2a3a2b", borderRadius: 8, color: "#e8e2d4", fontFamily: "'Inter', sans-serif", fontSize: "0.9rem", padding: "0.65rem 0.9rem", outline: "none", width: "100%" },
  btnRow: { display: "flex", gap: "0.75rem", flexWrap: "wrap" },
  btnPrimary: { background: "#c8924a", border: "none", color: "#0e1410", fontFamily: "'Inter', sans-serif", fontSize: "0.85rem", fontWeight: 500, padding: "0.6rem 1.5rem", borderRadius: 99, cursor: "pointer", letterSpacing: "0.02em" },
  btnSecondary: { background: "transparent", border: "1px solid #7a9e7e", color: "#7a9e7e", fontFamily: "'Inter', sans-serif", fontSize: "0.85rem", fontWeight: 500, padding: "0.6rem 1.5rem", borderRadius: 99, cursor: "pointer" },
  btnGhost: { background: "transparent", border: "none", color: "#4a5a4b", fontFamily: "'Inter', sans-serif", fontSize: "0.8rem", cursor: "pointer", textDecoration: "underline", textDecorationColor: "#2a3a2b", textUnderlineOffset: 3, padding: 0, alignSelf: "flex-start" },
  hint: { fontSize: "0.75rem", color: "#5a6a5b", letterSpacing: "0.04em", textTransform: "uppercase" },
  textarea: { width: "100%", background: "#131a14", border: "1px solid #2a3a2b", borderRadius: 10, color: "#e8e2d4", fontFamily: "'Inter', sans-serif", fontSize: "0.95rem", lineHeight: 1.65, padding: "0.9rem 1rem", resize: "none", height: 130, outline: "none" },
  dots: { display: "flex", gap: 8 },
  dot: { width: 6, height: 6, background: "#7a9e7e", borderRadius: "50%", animation: "bounce 1.2s infinite" },
  errorBox: { color: "#d08080", fontSize: "0.85rem", padding: "0.75rem 1rem", background: "#1a1010", borderRadius: 8, border: "1px solid #4a2020" },
};

export const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Inter:wght@300;400;500&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0e1410; }
  @keyframes bounce { 0%,80%,100%{transform:translateY(0)} 40%{transform:translateY(-6px)} }
  @keyframes stampIn { 0% { opacity:0; transform: scale(1.15) rotate(-2deg); } 100% { opacity:1; transform: scale(1) rotate(-2deg); } }
`;